import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';

export default {
  load(fastCashId) {
    const url = formUrl(`/api/v1/admin/fast_cash/${fastCashId}/memberships`);

    return FetchHelpers.get(url);
  },

  create(fastCashId) {
    const url = formUrl(`/api/v1/admin/fast_cash/${fastCashId}/memberships`);

    return FetchHelpers.post(url);
  },

  update(fastCashId, params) {
    const { membershipId } = params;
    const url = formUrl(
      `/api/v1/admin/fast_cash/${fastCashId}/memberships/${membershipId}`
    );

    return FetchHelpers.put(url, params);
  },
};
